<template>
    <div>
        <CommonPopupFrame :changeHeight="70" :changeBottom="0" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="padding-left: 12px; margin-top: 12px; border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; position: relative;">
                    <img @click="closeCompleteAction" style="width: 42px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700;">초대하기</div>
                </div>
            </div>
            <div style="flex: 1; overflow: hidden;" @touchmove.stop="() => { }">
                <InfinityScroll style="height: 100%;" :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="refresh">
                    <div style="padding: 0px 12px;">
                        <div @click="setSelectSchedule(each)" v-for="each, i in scheduleList" :key="i" style="position: relative; border-bottom: 1px solid #ebebeb; padding: 16px 0;">
                            <div :class="each.idx === selectSchedule ? 'is_check_active' : 'is_check'">
                                <img v-if="each.idx === selectSchedule" style="width: 13px;" :src="require('@/assets/img/check_white.png')" alt="">
                            </div>
                            <div style="font-weight: 500; line-height: 24px; margin-bottom: 3px;">{{ each.title }}</div>
                            <div style="display: flex; gap: 6px; align-items: center; margin-bottom: 5px;">
                                <img style="width: 14px;" :src="require('@/assets/img/schedule_black.png')" alt="">
                                <div style="font-size: 14px; font-weight: 500; line-height: 24px;">{{ transDate(each.join_begin_date_time) }} {{ each.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ each.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                            </div>
                            <div style="display: flex; gap: 12px; align-items: center; margin-top: 7px;">
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                                    <div style="color: #606060; font-weight: 500; font-size: 12px;">{{ each.theme }}</div>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                                    <div style="color: #606060; font-weight: 500; font-size: 12px;">{{ each.place_name }}</div>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                                    <div style="color: #606060; font-weight: 500; font-size: 12px;">{{ isNaN(parseInt(each.dues)) ? '참가비 없음' : parseInt(each.dues).toLocaleString('KO-KR') + '원' }}</div>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <span style="display: inline-block; width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></span>
                                    <div style="color: #606060; font-weight: 500; font-size: 12px;">{{ each.cur_cnt + '/' + each.max_cnt + ' 명' }}</div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 4px; margin-top: 12px;">
                            <img style="width: 18px;" :src="require('@/assets/img/plus_btn_main_color.png')" alt="">
                            <div @click=createSchedule style="color: var(--color-main); font-size: 14px; font-weight: 500;">스케줄 만들기</div>
                        </div>
                    </div>
                </InfinityScroll>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="inviteSchedule" v-if="selectSchedule" style="height: 48px; line-height: 48px; border-radius: 12px; background-color: #210f03; text-align: center; color: #fff; font-size: 14px; font-weight: 500; margin-top: 12px;">이 스케줄에 초대하기</div>
                <div v-else style="height: 48px; line-height: 48px; border-radius: 12px; background-color: #f5f5f5; text-align: center; color: #d9d9d9; font-size: 14px; font-weight: 500; margin-top: 12px;">초대하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";
import InfinityScroll from '@/components/common/InfinityScroll';
import { MODAL_MODE } from "@/Constants";
import moment from 'moment';
import ResponseCode from '../../ResponseCode';

export default {
    name: 'InviteMySchedule',
    components: {
        CommonPopupFrame, InfinityScroll
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        selectDong: {
            type: Object,
            default: () => { }
        },
        mode: {
            type: [String, Number],
            default: -1
        },
        region_result: {
            type: Object,
            default: () => { }
        },
        memberInfo: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            page: 1,
            MODAL_MODE: MODAL_MODE,
            scheduleList: [],
            today: '',
            selectSchedule: null,
            saveSelectSchedule: {},
            isEnableNextPageHandle: true,
        }
    },
    methods: {
        createSchedule() {
            this.$GlobalStore.addModal('NewMakeMercenarySchedule', {
                joinIdx: 0, isOpen: true,
                completeAction: () => {
                    this.page = 1;
                    this.scheduleList = [];
                    this.getScheduleList()
                }
            })
        },
        refresh() {
            this.page = 1
            this.scheduleList = []
            this.getScheduleList()
        },
        handleNextPage() {
            this.page++
            this.getScheduleList()
        },
        async getScheduleList() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            parameters.filter = 'made_by_me'
            parameters.is_open = 1
            // parameters.region_code = this.mode === MODAL_MODE.CURRENT_LOC ? this.region_result.region_code.slice(0, 6) : this.selectDong.code

            const res = await this.$Axios.get('/api/join/schedule/list', { params: parameters })
            const result = res.data.join_schedules

            if (result.length > 0) {
                this.isEnableNextPageHandle = true;
                this.scheduleList = [...this.scheduleList, ...result];
            }
        },
        transDate(date) {
            if (date.split(' ')[0] === this.today) {
                return ''
            } else {
                const transDate = this.$Util.getMMDDDayHangulStr(date).split(' ')
                transDate.splice(0, 1)

                return transDate.join(' ')
            }
        },
        setSelectSchedule(schedule) {
            if (this.selectSchedule === schedule.idx) {
                this.selectSchedule = null
                this.saveSelectSchedule = {}
                return
            }
            this.saveSelectSchedule = schedule
            this.selectSchedule = schedule.idx
            console.log(this.saveSelectSchedule)
        },
        async inviteSchedule() {
            const parameters = {};
            parameters.join_schedule_idx = this.saveSelectSchedule.idx
            parameters.member_idx = this.memberInfo.member_idx ? this.memberInfo.member_idx : this.memberInfo.idx
            parameters.member_type = this.memberInfo.member_type
            const res = await this.$Axios.post('/api/join/open/schedule/invitation/save', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                await this.$Axios.showChattingBySoccerJoinIdx(res.data.chat_idx);
                this.closeCompleteAction()
                this.selectSchedule = null
                this.saveSelectSchedule = {}
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            } else if (res.data.code === ResponseCode.SCHEDULE_INVITATION_REJECT) {
                this.$Util.showRejectSchedulePopup()
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                const today = moment().format('YYYY-MM-DD')
                this.today = today
                this.scheduleList = []
                this.getScheduleList()
            }
        }
    }
}
</script>

<style scoped>
.is_check {
    position: absolute;
    top: 50%;
    /* left: 50%; */
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    right: -12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.is_check_active {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    /* left: 50%; */
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    right: -12px;
    background-color: #210f03;
}
</style>